import firebase, { now } from "./firebase";

import Executions from "./db/Executions";
import Projects from "./db/Projects";
import TestCases from "./db/TestCases";
import TestSuits from "./db/TestSuits";

const db = firebase.firestore();

interface IUser {
  uid: string;
  name: string;
}

class DB {
  userUid: string = "";

  ensureUser(user: IUser) {
    this.userUid = user.uid;
    const userRef = db.collection("users").doc(user.uid);
    userRef.get().then(docRef => {
      if (!docRef.exists) {
        userRef.set(user);
      }
    });
  }

  executions(): Executions {
    return new Executions(db, this.userUid);
  }
  projects(): Projects {
    return new Projects(db, this.userUid);
  }
  testCases(): TestCases {
    return new TestCases(db, this.userUid);
  }
  testSuits(): TestSuits {
    return new TestSuits(db, this.userUid);
  }
}

export default new DB();
